export enum ERoles {
  SUPER_ADMIN = "super_admin ",
  REP_ADMIN = "rep_admin",
  REGION_ADMIN = "region_admin",
  COMPANY_ADMIN = "company_admin",
  OPERATOR_ROLE = "operator_role",
  INSPECTOR_ROLE = "inspector_role",
  REG_LEASING_INSPEKTOR = "reg_leasing_inspektor",
}

export enum ERoless {
  SUPER_ADMIN = "SUPER_ADMIN",
  REP_ADMIN = "REP_ADMIN",
  REGION_ADMIN = "REGION_ADMIN",
  COMPANY_ADMIN = "COMPANY_ADMIN",
  OPERATOR_ROLE = "OPERATOR",
  INSPECTOR_ROLE = "INSPECTOR",
  REPUBLIC_ADMIN = "REPUBLIC_ADMIN",
  DISTRICT_ADMIN = "DISTRICT_ADMIN",
  COMPANY_GROUP_ADMIN = "COMPANY_GROUP_ADMIN",
  COMPANY_GROUP_GPS_ADMIN = "COMPANY_GROUP_GPS_ADMIN",
  COMPANY_GPS_ADMIN = "COMPANY_GPS_ADMIN",
  REG_LEASING_INSPEKTOR = "REG_LEASING_INSPEKTOR",
}
